import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Input,
  InputLabel,
  Typography,
} from '@material-ui/core'
import validator from 'validator'
import {Redirect} from 'react-router-dom'
import classNames from 'classnames'
import {set} from 'lodash'
import {FuseAnimate} from '@fuse'
import {Mutation, Query} from 'react-apollo'
import {toast} from 'react-toastify'

import {REGISTER} from '../../../graphql/mutation'
import {USER} from '../../../graphql/query'
import {setLoginToken} from '../../../utils'

const styles = theme => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})


class RegisterPage extends Component {
  state = {
    email: '',
    password: '',
    done: false,
  }

  handleChange = event => {
    this.setState(set({...this.state}, event.target.name, event.target.value))
  }

  canBeSubmitted() {
    const {email, password} = this.state
    return validator.isEmail(email) && password.length > 1
  }

  render() {
    const {classes} = this.props
    const {email, password} = this.state
    if (this.state.done) {
      return <Redirect to="/login" />
    }
    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <Query query={USER}>
            {({ loading, data }) => {
            if (loading || !data.me) return null
            return <Redirect to="/auth" />
          }}
          </Query>
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                <img
                  className="w-128 m-32"
                  src="assets/images/logos/deeple_dark.png"
                  alt="logo"
                />

                <Typography variant="title" className="mt-16 mb-32">
                  Register your account
                </Typography>
                <Mutation
                  mutation={REGISTER}
                  refetchQueries={re => {
                    const token = re.data.register
                    if (token) {
                      setLoginToken(token)
                    }

                    return [{query: USER}]
                  }}
                >
                  {(register, {loading, error}) => {
                    return (
                      <form
                        name="registerForm"
                        noValidate
                        className="flex flex-col justify-center w-full"
                        onSubmit={e => {
                        e.preventDefault()
                        register({
                          variables: {
                            email,
                            password,
                          },
                        }).catch(registerError => {
                          registerError.graphQLErrors.forEach(({ message }) => {
                            toast.error(message, {
                              position: toast.POSITION.BOTTOM_RIGHT,
                            })
                          })
                        })
                      }}
                      >
                        <FormControl className="mb-16" fullWidth required>
                          <InputLabel>Email</InputLabel>
                          <Input
                            type="email"
                            name="email"
                            value={email}
                            onChange={this.handleChange}
                          />
                        </FormControl>

                        <FormControl className="mb-16" fullWidth required>
                          <InputLabel>Password</InputLabel>
                          <Input
                            type="password"
                            name="password"
                            value={password}
                            onChange={this.handleChange}
                          />
                        </FormControl>

                        <div
                          style={{display: 'flex', justifyContent: 'space-between'}}
                        >
                          <Button
                            color="secondary"
                            className="mt-16"
                            aria-label="Sign-In"
                            onClick={() => this.setState({done: true})}
                          >
                          Sign-In
                          </Button>
                          <Button
                            variant="raised"
                            type="submit"
                            className="w-224 mx-auto mt-16"
                            aria-label="Register"
                            disabled={!this.canBeSubmitted()}
                            style={{ background: '#663EE8', color: 'white' }}
                          >
                            Register
                          </Button>
                        </div>
                      </form>
                    )
                  }}
                </Mutation>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(RegisterPage)



// WEBPACK FOOTER //
// ./src/main/content/login/RegisterPage.js